import React, { createContext, useContext, useEffect } from 'react';

interface ThemeContextType {
  mode: 'light' | 'dark';
  toggleTheme: () => void;
}

const THEME_STORAGE_KEY = 'band-space-theme-mode';

const ThemeContext = createContext<ThemeContextType>({
  mode: 'dark',
  toggleTheme: () => {},
});

export const useThemeContext = () => useContext(ThemeContext);

/**
 * Landing is dark-only. Light mode left dark text on hardcoded dark surfaces
 * (and broke Drawer content portaled outside colored shells).
 */
export const ThemeContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === 'light') {
      window.localStorage.setItem(THEME_STORAGE_KEY, 'dark');
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ mode: 'dark', toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext };
